import React from 'react';
import Button from 'devextreme-react/button';
import './scheduler-tooltip.scss';

export const TooltipContentTemplate = ({ selectedAppointmentData, createRemoteTask, moveTask }) => {
  if (!selectedAppointmentData || !selectedAppointmentData.endDate) {
    return null;
  }
  const timeOptions = {
    hour: 'numeric',
    minute: 'numeric',
    hour12: false
  };
  const dateOptions = {
    ...timeOptions,
    weekday: 'short',
    day: 'numeric',
    month: 'numeric',
    year: 'numeric'
  };
  const timeString = `${selectedAppointmentData.startDate.toLocaleString(undefined, dateOptions)} - ${selectedAppointmentData.endDate.toLocaleTimeString(undefined, timeOptions)}`;

  return (<div className='appointment-tooltip'>
    <div className='title'>{selectedAppointmentData.text}</div>
    <div className='content'>
      <div className='date'>
        <Button icon='clock'
          focusStateEnabled={false}
          activeStateEnabled={false}
          hoverStateEnabled={false}
        />
        {timeString}
      </div>
      {selectedAppointmentData.description &&
        <div className='description'>
          <Button icon='textdocument'
            focusStateEnabled={false}
            activeStateEnabled={false}
            hoverStateEnabled={false}
          />
          {selectedAppointmentData.description}
        </div>
      }
    </div>
    <div className='buttons'>
      <Button
        className='button-success'
        text='Opdracht aanmaken'
        type='success'
        stylingMode='text'
        onClick={createRemoteTask}
      />
      <Button
        text='Opdracht verplaatsen'
        type='default'
        stylingMode='contained'
        onClick={moveTask}
      />
    </div>
  </div>);
};
